import React, {useEffect, useState, useContext} from "react";
import ApplicationContext from '../components/ApplicationContext';
import {postDataWithFetch, getLocalStorage, setLocalStorage} from '../components/Utils';
import Stories from '../components/Stories';
import ArrangeableList from '../components/ArrangeableList';
import ResetTopStoriesModal from '../components/ResetTopStoriesModal';
import "../assets/css/admin.css";
import "../assets/css/globals.css";
import NavBar from '../components/NavBar';
import SiteClosedModal from "../components/SiteClosedModal";
import TimeZoneConfig from '../components/TimeZoneConfig';
import ScraperRunner from '../components/ScraperRunner';

const AdminPage = ({ setData }) => {
	const data = useContext(ApplicationContext);
	const [linkData, setLinkData] = useState();
	const [modalOpen, setModalOpen] = useState(false);
	const [modal2Open, setModal2Open] = useState(false);

	const [currentCategoryList, setCurrentCategoryList] = useState();
	useEffect(() => {
		if (data.choicePairsList) {
			const category = getLocalStorage("CATEGORY");
			// console.log("DEBUG:  category = ", category);
			// console.log("DEBUG:  data.choicePairsList[category] = ", data.choicePairsList[category]);
			if (category !== "") {
				setCurrentCategoryList(data.choicePairsList[category]);
			}
			else {
				// Then just grab the first one from the first keyword search entry and default it to that.
				const keys = Object.keys(data.choicePairsList);
				// console.log("DEBUG:  keys[0] = ", keys[0]);
				// console.log("DEBUG:  data.choicePairsList[keys[0]] = ", data.choicePairsList[keys[0]]);
				setCurrentCategoryList(data.choicePairsList[keys[0]]);
				setLocalStorage("CATEGORY", keys[0]);
			}
		}
	}, [data.choicePairsList]);

	useEffect(() => {
		const username = getLocalStorage("username");
		// console.log("DEBUG", `AdminPage:  username = ${username}`);
		if (!username && username !== 'admin') {
			setLocalStorage('currentPage', 'login');
			data.currentPage = 'login';
			setData((prev) => ({ ...prev, currentPage: 'login' }))
		}
	}, [data, data.currentPage, setData]);

	const refreshLinkData = (list) => {
		if (!Array.isArray(list)) {
			return false;
		}

		return list?.map(e => {
			return {
				...e,
				URL_ORIGINAL: e['URL'],
				TITLE_ORIGINAL: e['TITLE'],
				ENABLED_ORIGINAL: e['ENABLED']				
			};
		});
	};

	useEffect(() => {
		if (data.linkData) {
			// data.linkData.forEach((e,i,arr) => {
			// 	console.log('DEBUG', e.TITLE, e.ENABLED);
			// });
			setLinkData(refreshLinkData(data.linkData));
		}
	}, [data.linkData]);

	const [showLinks, setShowLinks] = useState(false);
	const toggleShowLinks = () => {
		setShowLinks(!showLinks);
	};

	const [showTopStories, setShowTopStories] = useState(false);
	const toggleTopStories = () => {
		setShowTopStories(!showTopStories);
	};

	const [showArrangeCategories, setShowArrangeCategories] = useState(false);
	const toggleShowArrangeCategories = () => {
		setShowArrangeCategories(!showArrangeCategories);
	};

	const [showScraperRunner, setShowScraperRunner] = useState(false);
	const toggleShowScraperRunner = () => {
		setShowScraperRunner(!showScraperRunner);
	};

	const entryParser = (entry) => {
		// console.log("DEBUG:  AdminPage - entry = ", entry);
		const copy = JSON.parse(JSON.stringify(entry));
		return copy;
	};

	const [clickedSave, setClickedSave] = useState(false);
	const [statusText, setStatusText] = useState("");

	useEffect(() => {
		if (clickedSave && data.BASE_URL) {
			(async() => {
				if (linkData) {
					console.log('DEBUG:  Admin - linkData to be saved = ', linkData);

					const url = `${data.BASE_URL}index.php/link_data/update_link_data`;
					const parms = {NEW_LINK_DATA: JSON.stringify(linkData)};

					// console.log('DEBUG:  Admin - ', url);
					// console.log('DEBUG:  Admin - ', parms);
					const json = await postDataWithFetch(url, parms);
					setStatusText(`Saved ${json} records.`);

					if (parseInt(json) > 0) {
						let newList = linkData?.map(e => {
							return {
								...e, 
								URL_ORIGINAL: e['URL'], 
								TITLE_ORIGINAL: e['TITLE'],
								ENABLED_ORIGINAL: e['ENABLED']
							}
						});
						data.linkData = newList;
						// console.log('DEBUG', `Records changed:  ${json}`, newList[0]);
						setLinkData(newList);
					}

					// console.log('DEBUG:  output of update_link_data - ', typeof json, json);
					setClickedSave(false);
				}
				else {
					console.log('DEBUG:  Admin - linkData is empty');
				}
			})();
		}
	}, [data, data.BASE_URL, clickedSave, data.linkData, linkData]);

	const saveNewList = () => {
		setClickedSave(true);
	};

	const logout = (e) => {
		e.preventDefault();
		localStorage.removeItem('token');
		localStorage.removeItem('username');
		localStorage.removeItem('is_premium');
		localStorage.removeItem('currentPage');

		// This one is no longer need but clean it up if any user already 
		// has it.  At some point we will just delete this.
		localStorage.removeItem("ADMINUSER");

		setData((prev) => ({ ...prev, currentPage: 'login' }))
		setLocalStorage('currentPage', 'login');
		data.currentPage = 'login';
	};

	const handleCategoryClick = (category) => {
		// console.log('DEBUG:  called handleCategoryClick', category);
		if (data.choicePairsList) {
			setCurrentCategoryList(data.choicePairsList[category]);
			// console.log(data.choicePairsList[category]);
		}
	};

	// one for the section reveal and the other for the actual flag to keep the same site styls.
	// It might be stupid, but I will see once I can test it.
	// const [showSiteClosed, setShowSiteClosed] = useState(false);
	// const togglesetShowLinks = () => {
	// 	setShowSiteClosed(!showLinks);
	// };

	return (
		<>
			<h3 className="admin-user-container">
				<label className="all-links" onClick={logout}>Admin Logout</label>
			</h3>
			<h3 className="admin-title-tag all-links" onClick={() => {
					setModalOpen(true);
				}}>Site Closed Flag Management
			</h3>
		{modalOpen && <SiteClosedModal setOpenModal={setModalOpen} />}

		<TimeZoneConfig data={data} />

		<h3 className="admin-title-tag all-links" onClick={toggleShowScraperRunner}>Run News Scraper (tap to expand/collapse)</h3>
		<div style={{display: showScraperRunner ? 'block' : 'none'}}>
			<ScraperRunner />
		</div>

		<h3 className="admin-title-tag all-links" onClick={toggleShowLinks}>Organize special report links (tap to expand/collapse)</h3>
			<div style={{display: showLinks ? 'block' : 'none'}}>
				{linkData?.map((e,i,arr) => (
					<div key={i} className="form-row">
						<div className="form-group">
							<input type="text" value={e.TITLE} onChange={(e) => {
								// console.log('debug', 'entering on change title');
								let tmplinkData = [...linkData];
								tmplinkData[i].TITLE = e.target.value;
								setLinkData(tmplinkData);
								// console.log('debug', 'on change title', e.target.value);
							}} placeholder="Title" />
							<div className="button-container">
								{/* {(() => {
									console.log("DEBUG", `arr[i].ENABLED = ${arr[i].ENABLED}`);
								})()} */}
								<label className="checkbox-container">
									<input 
										className="sr-only" 
										type="checkbox" 
										checked={e.ENABLED === "1" ? true : false} 
										onChange={() => {
											let tempList = [...linkData];
											// console.log('DEBUG:  old value = ', tempList[i].ENABLED)
											tempList[i].ENABLED = tempList[i].ENABLED === "1" ? "0" : "1";
											// console.log('DEBUG:  new value = ', tempList[i].ENABLED)
											setLinkData(tempList);
										}}
									/>
									<div className="slider"></div>
									<span className="label">ENABLED</span>
								</label>
							</div>
						</div>
						<div className="form-group">
							<input type="text" value={e.URL} onChange={(e) => {
								// console.log('debug', 'entering on change url');
								let tmplinkData = [...linkData];
								tmplinkData[i].URL = e.target.value;
								setLinkData(tmplinkData);
								// console.log('debug', 'on change url', e.target.value);
							}} placeholder="URL" />
						</div>
					</div>
				))}
				<div className="btn-container">
					<button  className="my-button" style={{background: "#0077FF", color: "#fff"}} onClick={() => {
						if (linkData) {
							let tmplinkData = [...linkData];
							tmplinkData.push({URL:"", TITLE:"", ENABLED: "1"});
							setLinkData(tmplinkData);
						}
						else {
							let tmplinkData = [];
							tmplinkData.push({URL:"", TITLE:"", ENABLED: "1"});
							setLinkData(tmplinkData);
						}
					}}>ADD</button>
					<button className="my-button" style={{background: "#33B5E5", color: "#fff"}}  onClick={saveNewList}>SAVE</button>
				</div>
				<div className="status-text" style={{display: statusText?.length ? 'block' : 'none'}}>
					<p className="paragraph-status-text">{statusText}</p>
				</div>
			</div>

			{/* TODO: seems to share the same dialog space as the above site closed dialog for some reason */}
			<h3 className="admin-title-tag all-links" onClick={() => {
					setModal2Open(true);
				}}>Reset Top Stories
			</h3>
			{modal2Open && <ResetTopStoriesModal setOpenModal={setModal2Open} />}

			<h3 className="admin-title-tag all-links" onClick={toggleTopStories}>Set Top Stories/Tickers (tap to expand/collapse)</h3>
			<div style={{display: showTopStories ? 'block' : 'none'}}>
				<Stories enableAdmin={true} />
			</div>

			{data.choicePairsList && 
			<>
				<h3 className="admin-title-tag all-links" onClick={toggleShowArrangeCategories}>Organize categories (tap to expand/collapse)</h3>
				<div style={{display: showArrangeCategories ? 'block' : 'none'}}>
					<NavBar selectionIsCategory={true} handleCategoryClick={handleCategoryClick} enableSubMenu={false} showFlags={false} />
					<ArrangeableList list={currentCategoryList} entryParser={entryParser} />
				</div>
			</>}
		</>
	);
};

export default AdminPage;
